export const areaOptions = [
  '京',
  '津',
  '渝',
  '沪',
  '冀',
  '晋',
  '辽',
  '吉',
  '黑',
  '苏',
  '浙',
  '皖',
  '闽',
  '赣',
  '鲁',
  '豫',
  '鄂',
  '湘',
  '粤',
  '琼',
  '川',
  '贵',
  '云',
  '陕',
  '甘',
  '青',
  '蒙',
  '桂',
  '宁',
  '新',
]
export const areaBottomOptions = ['藏', '使', '领', '警', '学', '港', '澳']
export const areaLetterOptions1 = [
  'Q',
  'W',
  'E',
  'R',
  'T',
  'Y',
  'U',
  'I',
  'O',
  'P',
]
export const areaLetterOptions2 = ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L']
export const areaLetterOptions3 = ['Z', 'X', 'C', 'V', 'B', 'N', 'M']
export const areaDigit = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0']
